module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-72x72-precomposed-fc3fdad5da41ca3461dfde32abb7342f.png";